module.exports = __webpack_public_path__ + "static/media/uaf_logo.29a75ef1.svg";